


































































































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
	name: 'ProgressTrackerDesktop',
	components: {},
})
export default class ProgressTrackerDesktop extends Vue {
	@Prop() private title: string;
	@Prop() private qqStatus: string;
	@Prop() private setupStatus: string;
	@Prop() private verifyEmailStatus: string;
	@Prop() private verifyMobileStatus: string;
	@Prop() private setNewPasswordStatus: string;
	@Prop() private enterEmailStatus: string;
	@Prop() private isVerificationVisible: boolean;
	@Prop() private isVerifyEmailVisible: boolean;
	@Prop() private isVerifyMobileVisible: boolean;
	@Prop() private resetPasswordTracker: boolean;
	private trackerText: string;
	private stepsText: string;
	constructor() {
		super();
	}

	private created() {
		if (this.qqStatus === 'active') {
			this.trackerText = 'Quick Questions';
			this.stepsText = 'Steps 1 of ';
		}
		if (this.setupStatus === 'active') {
			this.trackerText = 'Account Setup';
			this.stepsText = 'Steps 2 of ';
		}
		if (this.verifyEmailStatus === 'active') {
			this.trackerText = 'Verify Email';
			this.stepsText = 'Steps 3 of ';
		}
		if (this.verifyMobileStatus === 'active') {
			this.trackerText = 'Verify Mobile';
			this.stepsText = 'Steps 4 of ';
		}

		if (this.isVerifyMobileVisible) {
			this.stepsText = this.stepsText + '4';
		} else {
			this.stepsText = this.stepsText + '3';
		}
	}
	private signIn() {
		this.$router.push({
			name: 'login',
		});
	}
	private goToPrevious() {
		if (this.qqStatus === 'active') {
			this.$router.push({
				name: 'login',
			});
		} else if (this.setupStatus === 'active') {
			this.$router.push({
				name: 'quick-questions',
			});
		} else if (this.verifyEmailStatus === 'active') {
			this.$router.push({
				name: 'account-setup',
			});
		} else if (this.verifyMobileStatus === 'active') {
			this.$router.push({
				name: 'verify-email',
			});
		}
	}
}
